import type { Optional } from '@festina-life/core'
import { CardItem, CardItems } from '@festina-life/ui/structure'
import type { ReactNode } from 'react'

import { useAmountFormatter } from '../../hooks/useAmountFormatter'
type Props = {
  id: string
  name: string
  children: ReactNode
  amount: Optional<number>
}

export function CoverCard({ id, name, amount, children }: Props) {
  const { format } = useAmountFormatter()

  return (
    <CardItems title={id}>
      <CardItem title={name} value={format(amount)} />
      {children}
    </CardItems>
  )
}
